var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueSlider,{staticClass:"c-slider-wrapper",attrs:{"drag-on-click":"","min":_vm.min,"max":_vm.max,"tooltip-formatter":_vm.formatter,"disabled":_vm.disabled,"height":8},model:{value:(_setup.model),callback:function ($$v) {_setup.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }